const key = "add-invalid-timeout";

const applicable = (resp) => {
	return resp?.config.url.match(/api\/forms\/[0-9]*$/);
};

const modify = (resp) => {
	if(!resp?.data?.Data)
		return;
	
	resp.data.Data.InvalidTimeout = "PT3M"; // 3 minutes
};

export const addInvalidTimeout = [key, applicable, modify];